import { useTranslation } from '@/i18n'

export function LoadingScreen({ compact = false }: { compact?: boolean } = {}) {
  const { t } = useTranslation()
  return (
    <div className={`loading-screen relative left-1/2 -mt-5 w-screen -translate-x-1/2 ${compact ? '' : 'min-h-[60vh]'}`} role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">{t('Pagina wordt geladen')}</span>
      <div className="app-progress-track h-px w-full overflow-hidden">
        <div className="animate-matches-loading-bar h-full w-1/3 rounded-full bg-accent-500" />
      </div>
    </div>
  )
}
